import { C as c } from "./component-B88NZlIm.js";
import { T as n } from "./events-CnaEWcY_.js";
import { d as s } from "./utilities-D-QcnR4L.js";
class r extends c {
  #t;
  connectedCallback() {
    (super.connectedCallback(),
      (this.#t = this.#e.bind(this)),
      document.addEventListener(n.variantUpdate, this.#t));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.#t && document.removeEventListener(n.variantUpdate, this.#t));
  }
  #e(a) {
    const t = a.detail?.data?.html;
    if (!t || typeof t.querySelector != "function") return;
    const e = this.dataset.blockId;
    if (!e) return;
    const o = `availability-notification[data-block-id="${CSS.escape(e)}"]`,
      i = t.querySelector(o);
    if (!i) {
      this.innerHTML = "";
      return;
    }
    this.innerHTML = i.innerHTML;
  }
}
s("availability-notification", r);
